<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{PageTitle}}</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Discount Type-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="discountType">Discount Type :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="discountType" type="text" class="form-control" id="discountType" placeholder="Discount Type">
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.discountType}}</font>
                                </div>
                            </div>
                            <!--Title-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="title">Title :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="title" type="text" class="form-control" id="title" placeholder="Title">
                                    <font class="text-danger">{{frontendErrors.title}}</font>
                                </div>
                            </div>
                            <!--Image-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="drop1">Discount Image :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        @vdropzone-total-upload-progress="progressOfUload"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger"> {{frontendErrors.fileUpload}}<strong id="uploadErrorMsg" class="error"></strong></font>
                                </div>
                            </div>
                            <!--Start Date-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="startDate" slot="before">Start DateTime :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <datePicker id="StartDate" v-model="startDate" :config="optionsStart" @dp-change="changeStartDt()"></datePicker>
                                    <font class="text-danger">{{frontendErrors.startDate}}</font>
                                </div>
                            </div>
                            <!--End Date-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="endDate" slot="before">End DateTime :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <datePicker id="EndDate" v-model="endDate" :config="optionsEnd" @dp-change="changeEndDt()"></datePicker>
                                    </datetime>
                                    <font class="text-danger">{{frontendErrors.endDate}}</font>
                                </div>
                            </div>
                            <!--Phone No.-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="phoneNo">Phone No. :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="phoneNo" type="text" class="form-control" id="phoneNo" placeholder="Phone No.">
                                    <font class="text-danger">{{frontendErrors.phoneNo}}</font>
                                </div>
                            </div>
                            <!--Email-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="email">Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="email" type="text" class="form-control" id="email" placeholder="Email">
                                    <font class="text-danger">{{frontendErrors.email}}</font>
                                </div>
                            </div>
                            <!--Location-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="locationId"
                                              multiple
                                              @change="changedValue"
                                              @input="changedValueLocation()"
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.locationId}}</font>
                                </div>
                            </div>
                            <!--Status-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="status">Status :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="status"
                                              name="status"
                                              @input="changedValueStatus()"
                                              id="status"
                                              label="text"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="statusArr"
                                              placeholder="Select Status">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.status}}</font>
                                </div>
                            </div>
                            <!--Role ID-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleData">Discount For :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="roleId"
                                              @change="changedValue"
                                              @input="changedValueSearchFor()"
                                              name="roleId"
                                              id="roleData"
                                              label="text"
                                              :filterable="false"
                                              :options="roleArr"
                                              @search="onSearchRole"
                                              placeholder="Select Discount For">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{frontendErrors.roleId}}</font>
                                </div>
                            </div>
                            <!--Description-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="description">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="description" v-model="description" class= "" ref="tm" :other_options="options"></tinymce>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="instructionTitle">Instruction Title :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="instructionTitle" type="text" class="form-control" id="instructionTitle" placeholder="instructionTitle">
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-1 paddingleft0">
                                    <button type="button" v-on:click="addNewStep" class="btn btn-block btn-success">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <div class="mt-2 col-11 paddingleft0">
                                    Would you like add more Step?
                                </div>
                            </div>
                            <div class="row col-12" v-for="(instruction, index) in instructions">
                                <div class="col-12 forms-block">
                                    <div class="col-1 paddingleft0">
                                        <button type="button" v-on:click="removeStep(index)" class="btn btn-block btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="col-11 paddingleft0">
                                        <div class="col-3 paddingleft0">
                                            <div class="form-label" for="instructionTitle">Step :</div>
                                        </div>
                                        <div class="col-9 paddingleft0">
                                            <input v-model="instruction.step" type="text"
                                                   name="instructions[][step]" class="form-control" placeholder="Instruction Step">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" >Button Links</div>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-1 paddingleft0">
                                    <button type="button" v-on:click="addNewLink" class="btn btn-block btn-success">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <div class="mt-2 col-11 paddingleft0">
                                    Would you like add more Discount Links?
                                </div>
                            </div>
                            <div class="row col-12" v-for="(discountLink, index) in discountLinks">
                                <div class="col-12 forms-block">
                                    <div class="col-1 paddingleft0">
                                        <button type="button" v-on:click="removeApartment(index)" class="btn btn-block btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="col-11 paddingleft0">
                                        <div class="col-6 paddingleft0">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label" >Button Title :</div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input v-model="discountLink.button_title" type="text"
                                                       name="discountLinks[][button_title]" class="form-control" placeholder="Button Title">
                                            </div>
                                        </div>
                                        <div class="col-6 paddingleft0">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label">Button Text :</div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input v-model="discountLink.button_text" type="text"
                                                       name="discountLinks[][button_text]" class="form-control" placeholder="Button Text">
                                            </div>
                                        </div>
                                        <div class="col-3 paddingleft0">
                                            <!--<div class="row col-9">
                                                <div class="form-label" for="title">Is URL : </div>
                                            </div>
                                            <div class="col-3 paddingleft0">-->
                                            <b-form-checkbox
                                                :id="'checkbox-'+index"
                                                v-model="discountLink.is_file"
                                                name="discountLinks[][is_file]"
                                                value="1"
                                                unchecked-value="0"
                                                v-on:change="checkIsURL(index)"
                                                class="file_url_checkbox"
                                                >
                                                Is File<!-- : {{docObj.is_file}}-->
                                            </b-form-checkbox>
                                            <!--</div>-->
                                        </div>
                                        <div :id="'input_url_'+index" class="col-6 paddingleft0">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label">Button Link :</div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input v-model="discountLink.button_link" type="text"
                                                       name="discountLinks[][button_link]" class="form-control" placeholder="Button Link">
                                            </div>
                                        </div>
                                        <div style="display: none;" :id="'input_doc_'+index" class="col-6 paddingleft0">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label">Upload File :</div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="button" id="id" value="Upload File"  v-on:click="clickonFileButton(index)" /><span :class="'input_file_name_'+index">{{discountLinks[index].doc_name}}</span>
                                                <input 
                                                    style="display: none;" type="file" 
                                                    v-on:change="handleFilesUpload(index)"
                                                    :id="'upload_'+index"
                                                    name="discountLinks[][doc]" >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addDiscountBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addDiscount()">
                                    <input id="addAndContinueDiscountBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addDiscount(flag='Save and Continue')">
                                    <input id="CancelDiscount" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import tinymce from 'vue-tinymce-editor';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import moment from 'moment';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    var myDate = new Date();

    export default {
        name: 'AddDiscount',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'datePicker': datePicker,
            vueDropzone: vue2Dropzone,
            'tinymce': tinymce,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                editperk_id: 0,
                PageTitle: 'Add Discount',
                discountType: '',
                phoneNo: '',
                email: '',
                imageSize: '',
                instructionTitle: '',
                startDate: myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + myDate.getDate() + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + ('0' + (myDate.getSeconds())).slice(-2),
                endDate: myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + myDate.getDate() + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + ('0' + (myDate.getSeconds())).slice(-2),
                options: {
                    /*language_url: 'http://example.com/js/langs/fa_IR.js' //This url points to location of persian language file.*/
                },
                discountLink: {
                    button_title: '',
                    button_text: '',
                    button_link: '',
                    is_file: 0,
                    doc: '',
                    doc_name: '',
                },
                discountLinks: [{
                        button_title: '',
                        button_text: '',
                        button_link: '',
                        is_file: 0,
                        doc: '',
                        doc_name: '',
                    }],
                instruction: {
                    step: ''
                },
                instructions: [{
                        step: ''
                    }],
                //DropZone
                dropzoneOptions: {
//                    url: "https://httpbin.org/post",
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1,
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    acceptedFiles: ".jpg, .jpeg, .png, .JPG, .JPEG, .PNG",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },
                imageURL: '',
                isDropFileUploaded: false,
                filePath: '',

                optionsStart: {
                    format: 'YYYY-MM-DD HH:mm:ss',
                    //maxDate: new Date(),
                    maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1000)),
                },
                optionsEnd: {
                    format: 'YYYY-MM-DD HH:mm:ss',
                    minDate: new Date(),
                },
                //V-model
                isFileUploaded: false,
                isDropFileUploaded: false,
                title: '',
                description: '',
                duration: '',
                locationId: '',
                locationArr: [],

                roleId: '',
                roleArr: [],
                status: {value: 'active', text: 'Active'},
                statusArr: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'}
                ],

                //Errors
                frontendErrors: {
                    discountType: '',
                    /*title: '',*/
                    fileUpload: '',
                    startDate: '',
                    endDate: '',
                    locationId: '',
                    roleId: '',
                    status: '',
                    phoneNo: '',
                    email: '',
                },
                contactPersonError: '',
                scheduledForError: '',
                statusError: '',
                typeError: '',
                fileUploaded: true,
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.loadLocationsAdd();
            self.loadRoleFirst();
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'updatediscount') {
                if (segments[3]) {
                    self.editperk_id = segments[3];
                    self.PageTitle = "Update Discount";
                    self.loadDiscount();
                    $("#addAndContinueDiscountBtn").hide();
                    $("#addDiscountBtn").val("Update");
                    $("#benefitHeader").text("Edit Benefit Video");
                }
            }

//            var editor = $("#placeHolder").Editor();
//            $(document).ready(function () {
//                $("#txtEditor").Editor();
//            });
            $("#discountType").on('keyup', function () {
                self.frontendErrors.discountType = '';
            });
            /*$("#title").on('keyup', function () {
             self.frontendErrors.title = '';
             });*/
            $("#startDate").on('keyup', function () {
                self.frontendErrors.startDate = '';
            });
            $("#endDate").on('keyup', function () {
                self.frontendErrors.endDate = '';
            });
            $("#locationId").on('keyup', function () {
                self.frontendErrors.locationId = '';
            });
            $("#roleId").on('keyup', function () {
                self.frontendErrors.roleId = '';
            });
            $("#phoneNo").on('keyup', function () {
                self.frontendErrors.phoneNo = '';
            });
            $("#email").on('keyup', function () {
                self.frontendErrors.email = '';
            });

            $("#alertError").hide();
        },
        methods: {
            checkIsURL: function (index) {
                self.$nextTick(function () {
                    if (self.discountLinks[index]['is_file'] == 1) {
                        $('#input_url_' + index).hide();
                        $('#input_doc_' + index).show();
                    } else {
                        $('#input_url_' + index).show();
                        $('#input_doc_' + index).hide();
                    }
                });
            },
            clickonFileButton: function (index) {
                $("#upload_" + index).click();
            },
            handleFilesUpload: function (index) {
                let uploadedFiles = "";
                self.$nextTick(function () {
                    uploadedFiles = $("#upload_" + index).prop('files')[0];
                    uploadedFiles = (uploadedFiles === null || typeof uploadedFiles === "undefined" || uploadedFiles == '') ? '' : uploadedFiles;
                    if (uploadedFiles != '') {
                        self.discountLinks[index]['doc'] = uploadedFiles;
                        self.discountLinks[index]['doc_name'] = uploadedFiles.name;
                        $('.input_file_name_' + index).html(uploadedFiles.name);
                    }
                });
                /*this.getImagePreviews();*/
            },
            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
            },
            uploadManually(file) {
                if (self.filePath != '') {
                    var file_name = self.getFileName(self.filePath);
                    let file_type = self.getFileType(file_name);
                    let url = self.filePath;
                    let file_size = self.imageSize;
                    /*console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);*/
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*                     
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },
            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },
            checkForm: function () {
                var checked = true;
                self.frontendErrors.discountType = '';
                if (!self.discountType) {
                    self.frontendErrors.discountType = "Discount Type is required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.frontendErrors.phoneNo = "";
                if (self.phoneNo && !String(self.phoneNo).match(/^[0-9]*$/)) {
                    self.frontendErrors.phoneNo = "Phone Number Must Be Numeric";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.phoneNo && String(self.phoneNo).match(/^[0-9]*$/) && self.phoneNo.length < 10) {
                    self.frontendErrors.phoneNo = "Phone Number Must Be Of Minimum 10 Digits";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.phoneNo && String(self.phoneNo).match(/^[0-9]*$/) && self.phoneNo.length > 13) {
                    self.frontendErrors.phoneNo = "Phone Number Must Be Of Maximum 13 Digits";
                    if (checked) {
                        checked = false;
                    }
                }
                self.frontendErrors.email = '';
                if (self.email && !self.validEmail(self.email)) {
                    self.frontendErrors.email = 'Please Enter Valid Email';
                    if (checked) {
                        checked = false;
                    }
                }
                /*if (!self.title) {
                 self.frontendErrors.title = "Title is required";
                 if (checked) {
                 checked = false;
                 }
                 }*/
                self.frontendErrors.startDate = '';
                /*if (!self.startDate) {
                 self.frontendErrors.startDate = "Start Date is required";
                 if (checked) {
                 checked = false;
                 }
                 }
                 if (!self.endDate) {
                 self.frontendErrors.endDate = "End Date is required";
                 if (checked) {
                 checked = false;
                 }
                 }*/
                self.frontendErrors.locationId = "";
                if (self.locationId.length === 0) {
                    self.frontendErrors.locationId = "State is required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.frontendErrors.roleId = "";
                if (!self.roleId) {
                    self.frontendErrors.roleId = "Discount For is required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.frontendErrors.status = "";
                if (!self.status) {
                    self.frontendErrors.status = "Status is required";
                    if (checked) {
                        checked = false;
                    }
                }
                self.frontendErrors.fileUpload = "";
                if (self.isFileUploaded == false) {
                    self.frontendErrors.fileUpload = "Discount Image is required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.fileUploaded == false) {
                    self.frontendErrors.fileUpload = "Please Wait While Image Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },

            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            addNewLink: function () {
                self.discountLinks.push(Vue.util.extend({}, self.discountLink))
            },
            removeApartment: function (index) {
                Vue.delete(self.discountLinks, index);
                $.each(self.discountLinks, function (i) {
                    self.checkIsURL(i);
                });
            },
            addNewStep: function () {
                self.instructions.push(Vue.util.extend({}, self.instruction))
            },
            removeStep: function (index) {
                Vue.delete(self.instructions, index);
            },
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listdiscount');
            },

            removedSelectedFile(file, xhr, error) {
                var filePath = JSON.parse(file.xhr.response);
                self.imageURL = '';
                self.isDropFileUploaded = false;
                self.isFileUploaded = false;
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vfileSuccess: function (file, response) {
                if (self.isDropFileUploaded == false) {
                    self.imageURL = file.dataURL;
                    self.isDropFileUploaded = true;
                    self.isFileUploaded = true;
                    self.frontendErrors.fileUpload = '';
                    /*self.$refs.croppieRef.bind({
                     url: self.imageURL,
                     });*/
                    $("#vuecrop").show();
                    $("#rotateAnti").show();
                    $("#rotateClock").show();
                    $("#crop").show();
                    var filePathJSON = JSON.parse(file.xhr.response);
                    self.filePath = filePathJSON.content.media_path;
                    self.imageSize = file.size;
                } else if (self.isDropFileUploaded == true) {
                    self.removedSelectedFile(file);
                    var err = "You can Upload Only One Image";
                    $("#uploadErrorMsg").html(err);
                }
            },
            changeStartDt: function () {
                self.frontendErrors.startDate = "";
                self.optionsEnd.minDate = self.startDate;
                //console.log('mindate 2 ' + self.optionsEnd.minDate+"dsfsd");
            },
            changeEndDt: function () {
                self.frontendErrors.endDate = "";
                self.optionsStart.maxDate = self.endDate;
                //console.log('maxdate 2 ' + self.optionsStart.maxDate +"fad");
            },
            changedValue: function (value) {
                //console.log(value);
            },
            onSearchRole(search, loading) {
                if (search.length >= 1) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadRole(loading, search, this);
                }
            },
            changedValueSearchFor: function () {
                self.frontendErrors.roleId = "";
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },
            changedValueLocation: function () {
                self.frontendErrors.locationId = '';
            },
            changedValueStatus: function () {
                self.frontendErrors.status = '';
            },
            changeStartDate: function () {
                self.frontendErrors.startDate = "";
            },
            changeEndDate: function () {
                self.frontendErrors.endDate = "";
            },
            loadRole(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    search: search
                };
                HTTP.post("getroles", data, config)
                        .then(function (response) {
                            self.roleArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            /*console.log(err);*/
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadRoleFirst() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    /*search: ''*/
                };
                HTTP.post("getroles", data, config)
                        .then(function (response) {
                            self.roleArr = response.data.content;
                        })
                        .catch(function (err) {
                            /*console.log(err);*/
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = response.data.content;
                            /*$.each(response.data.content, function (i) {
                             if (response.data.content[i].value == 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });
                             $.each(response.data.content, function (i) {
                             if (response.data.content[i].value != 0) {
                             self.locationArr.push(response.data.content[i]);
                             }
                             });*/
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
//                            self.error = response.data.message;
                            }
                        });
            },

            loadDiscount() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.post("getdiscount/" + segments[3], data, config)
                        .then(function (response) {
                            self.optionsStart.maxDate = response.data.content[0].end_date;
                            self.optionsEnd.minDate = response.data.content[0].start_date;
                            setTimeout(function () {
                                // self.locationId = {
                                //     value: response.data.content[0].location_id,
                                //     text: response.data.content[0].location_name,
                                // };
                                self.locationId = [];
                                for (var i = 0; i < response.data.content[0].location.length; i++) {
                                    self.locationId.push({'text': response.data.content[0].location[i].name, 'value': response.data.content[0].location[i].id});
                                }
                                self.videourl = response.data.content[0].videoUrl;
                                self.status = {
                                    value: response.data.content[0].status,
                                    text: self.formatString(response.data.content[0].status),
                                };
                                self.roleId = {
                                    value: response.data.content[0].role_id,
                                    text: response.data.content[0].role_name,
                                };
                                self.discountType = response.data.content[0].discount_type;
                                self.title = response.data.content[0].title;
                                self.startDate = response.data.content[0].start_date;
                                self.endDate = response.data.content[0].end_date;
                                self.phoneNo = response.data.content[0].phone_no;
                                self.email = response.data.content[0].email;
                                self.description = response.data.content[0].description;
                                self.instructionTitle = response.data.content[0].instruction_title;
                                self.instructions = response.data.content[0].instruction;
                                self.discountLinks = response.data.content[0].discount_links;
                                self.filePath = response.data.content[0].image;
                                if (self.filePath != '') {
                                    self.isFileUploaded = true;
                                    self.imageSize = response.data.content[0].image_size;
                                    self.uploadManually();
                                }
                                self.$nextTick(function () {
                                    $("#addDiscountBtn").prop("disabled", false);
                                    $("#CancelDiscount").prop("disabled", false);
                                    $.each(self.discountLinks, function (i) {
                                        self.checkIsURL(i);
                                    });
                                });
                            }, 200);
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            addDiscount(flag) {
                if (self.checkForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var type = document.getElementById("type");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var locationsId = '';
                    for (var i = 0; i < self.locationId.length; i++) {
                        locationsId += (self.locationId[i].value) + ',';
                    }
                    locationsId = locationsId.replace(/,\s*$/, "");
                    var data = new FormData();
                    data.append('discount_type', self.discountType);
                    data.append('title', self.title);
                    data.append('file_path', self.filePath);
                    data.append('image_size', self.imageSize);
                    data.append('start_date', self.startDate);
                    data.append('end_date', self.endDate);
                    data.append('phone_no', self.phoneNo);
                    data.append('email', self.email);
                    data.append('location_id', locationsId);
                    data.append('status', self.status.value);
                    data.append('role_id', self.roleId.value);
                    data.append('description', self.description);
                    data.append('instruction_title', self.instructionTitle);
                    data.append('instructions', JSON.stringify(self.instructions));
                    data.append('button_count', self.discountLinks.length);
                    for (var i = 0; i < self.discountLinks.length; i++) {
                        data.append('button_title' + [i], self.discountLinks[i].button_title);
                        data.append('button_text' + [i], self.discountLinks[i].button_text);
                        data.append('button_link' + [i], self.discountLinks[i].button_link);
                        data.append('is_file' + [i], self.discountLinks[i].is_file);
                        data.append('doc' + [i], self.discountLinks[i].doc);
                        data.append('doc_name' + [i], self.discountLinks[i].doc_name);
                    }
                    if (segments[2] == 'updatediscount') {
                        if (self.editperk_id) {
                            data.append('id', self.editperk_id);
                            $("#addDiscountBtn").val("Updating ...");
                            $("#addDiscountBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelDiscount").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueDiscountBtn").val("Saving ...");
                                $("#addAndContinueDiscountBtn").prop("disabled", true);
                                $("#addDiscountBtn").prop("disabled", true);
                                $("#CancelDiscount").prop("disabled", true);
                            } else {
                                $("#addDiscountBtn").val("Saving ...");
                                $("#addDiscountBtn").prop("disabled", true);
                                $("#addAndContinueDiscountBtn").prop("disabled", true);
                                $("#CancelDiscount").prop("disabled", true);
                            }
                        }
                    } else {
                        if (flag == "Save and Continue") {
                            $("#addAndContinueDiscountBtn").val("Saving ...");
                            $("#addAndContinueDiscountBtn").prop("disabled", true);
                            $("#addDiscountBtn").prop("disabled", true);
                            $("#CancelDiscount").prop("disabled", true);
                        } else {
                            $("#addDiscountBtn").val("Saving ...");
                            $("#addDiscountBtn").prop("disabled", true);
                            $("#addAndContinueDiscountBtn").prop("disabled", true);
                            $("#CancelDiscount").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("savediscount", data, config)
                            .then(function (response) {
                                self.removeAllFiles();
                                if (segments[2] == 'updatediscount') {
                                    if (self.editperk_id) {
                                        //console.log(self.editperk_id);
                                        $("#addDiscountBtn").val("Update");
                                        $("#addDiscountBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelDiscount").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueDiscountBtn").val("Save and Continue");
                                            $("#addAndContinueDiscountBtn").prop("disabled", false);
                                            $("#addDiscountBtn").prop("disabled", false);
                                            $("#CancelDiscount").prop("disabled", false);
                                        } else {
                                            $("#addDiscountBtn").val("Save");
                                            $("#addDiscountBtn").prop("disabled", false);
                                            $("#addAndContinueDiscountBtn").prop("disabled", false);
                                            $("#CancelDiscount").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueDiscountBtn").val("Save and Continue");
                                        $("#addAndContinueDiscountBtn").prop("disabled", false);
                                        $("#addDiscountBtn").prop("disabled", false);
                                        $("#CancelDiscount").prop("disabled", false);
                                    } else {
                                        $("#addDiscountBtn").val("Save");
                                        $("#addDiscountBtn").prop("disabled", false);
                                        $("#addAndContinueDiscountBtn").prop("disabled", false);
                                        $("#CancelDiscount").prop("disabled", false);
                                    }
                                }

                                if (response.data.status == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");

                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.discountType = '';
                                        self.title = '';
                                        self.filePath = "";
                                        self.startDate = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + myDate.getDate() + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + ('0' + (myDate.getSeconds())).slice(-2);
                                        self.endDate = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + myDate.getDate() + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + ('0' + (myDate.getSeconds())).slice(-2);
                                        self.phoneNo = '';
                                        self.email = '';
                                        self.locationId = '';
                                        self.roleId = '';
                                        self.description = '';
                                        self.instructionTitle = '';
                                        self.instructions = [{step: ''}];
                                        self.discountLinks = [{
                                                button_title: '',
                                                button_text: '',
                                                button_link: '',
                                                is_file: 0,
                                                doc: '',
                                                doc_name: '',
                                            }];
                                        self.status = {value: 'active', text: 'Active'};
                                        /*$("#status option[value='']").attr('selected', true);
                                         $("#type option[value='']").attr('selected', true);*/
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                if (segments[2] == 'updatediscount') {
                                    if (self.editperk_id) {
                                        $("#addDiscountBtn").val("Update");
                                        $("#addDiscountBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelDiscount").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueDiscountBtn").prop("disabled", false);
                                            $("#addAndContinueDiscountBtn").val("Save and Continue");
                                            $("#addDiscountBtn").prop("disabled", false);
                                            $("#CancelDiscount").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            self.discountType = '';
                                            self.title = '';
                                            self.filePath = "";
                                            self.startDate = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + myDate.getDate() + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + ('0' + (myDate.getSeconds())).slice(-2);
                                            self.endDate = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + myDate.getDate() + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + ('0' + (myDate.getSeconds())).slice(-2);
                                            self.phoneNo = '';
                                            self.email = '';
                                            self.locationId = '';
                                            self.roleId = '';
                                            self.description = '';
                                            self.instructionTitle = '';
                                            self.instructions = [{step: ''}];
                                            self.discountLinks = [{
                                                    button_title: '',
                                                    button_text: '',
                                                    button_link: '',
                                                    is_file: 0,
                                                    doc: '',
                                                    doc_name: '',
                                                }];
                                            self.status = {value: 'active', text: 'Active'};
                                            /*$("#status option[value='']").attr('selected', true);
                                             $("#type option[value='']").attr('selected', true);*/

                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addDiscountBtn").val("Save");
                                            $("#addDiscountBtn").prop("disabled", false);
                                            $("#addAndContinueDiscountBtn").prop("disabled", true);
                                            $("#CancelDiscount").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueDiscountBtn").prop("disabled", false);
                                        $("#addAndContinueDiscountBtn").val("Save and Continue");
                                        $("#addDiscountBtn").prop("disabled", false);
                                        $("#CancelDiscount").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        self.discountType = '';
                                        self.title = '';
                                        self.filePath = "";
                                        self.startDate = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + myDate.getDate() + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + ('0' + (myDate.getSeconds())).slice(-2);
                                        self.endDate = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + myDate.getDate() + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + ('0' + (myDate.getSeconds())).slice(-2);
                                        self.phoneNo = '';
                                        self.email = '';
                                        self.locationId = '';
                                        self.roleId = '';
                                        self.description = '';
                                        self.instructionTitle = '';
                                        self.instructions = [{step: ''}];
                                        self.discountLinks = [{
                                                button_title: '',
                                                button_text: '',
                                                button_link: '',
                                                is_file: 0,
                                                doc: '',
                                                doc_name: '',
                                            }];
                                        self.status = {value: 'active', text: 'Active'};
                                        /*$("#status option[value='']").attr('selected', true);
                                         $("#type option[value='']").attr('selected', true);*/
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addDiscountBtn").val("Save");
                                        $("#addDiscountBtn").prop("disabled", false);
                                        $("#addAndContinueDiscountBtn").prop("disabled", true);
                                        $("#CancelDiscount").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }

                //
            },
            formatString(data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.frontendErrors.fileUpload = "";
                } else {
                    self.fileUploaded = false;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/employeeperks/AddDiscount.vue